module.exports = __webpack_public_path__ + "static/media/nwnp32_printer_icon.79686440.ico";